// Imports
import axios from 'axios';

// Ajax Load More
let loadMore = document.getElementById('loadMore')
let content = document.getElementById('loadAnchor')
let params = new URLSearchParams(window.location.search)
let page = 1

if (params.get('practice') || params.get('service')) {
    params = params.toString() + '&'
} else {
    params = ''
}

loadMore.addEventListener('click', () => {
    page++
    fetchWork(page)
})

function fetchWork(page) {
    // Get more entries
    axios
        .get(`/api/work?${params}page=${page}`)
        .then(function (response) {
            content.insertAdjacentHTML('beforebegin', response.data)
        })

    // Check if there is a next page, if not remove load more
    let pageNext = page + 1

    axios.get(`/api/work?${params}page=${pageNext}`)
        .then(function (response) {
            if(response.data.length <= 5) {
                loadMore.parentElement.remove()
            }
        })
}
